<template>
  <div class="aydem-popup-wrapper">
    <!-- Tetikleyici buton -->
    <button class="aydem-popup-trigger" @click="isOpen = !isOpen" v-if="!isOpen">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 14H5.17L4 17.17V4h16v12z"/>
        <path d="M7 9h10v2H7zm0-3h10v2H7zm0 6h7v2H7z"/>
      </svg>
      <span>Beni Arayın</span>
    </button>

    <!-- Popup -->
    <transition name="popup-slide">
      <div class="aydem-popup" v-if="isOpen">
        <button class="aydem-popup__close" @click="isOpen = false">✕</button>

        <div class="aydem-popup__header" v-if="!submitted">
          <h3>Karar veremediniz mi?</h3>
          <p>Formu doldurun, müşteri temsilcilerimiz sizi arayarak ihtiyacınıza yönelik bilgi versinler.</p>
        </div>

        <!-- Başarı mesajı -->
        <div class="aydem-popup__success" v-if="submitted">
          <div class="aydem-popup__success-icon">
            <svg viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
              <circle cx="26" cy="26" r="25" fill="none" stroke="#22c55e" stroke-width="2"/>
              <path fill="none" stroke="#22c55e" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" d="M14 27l8 8 16-16"/>
            </svg>
          </div>
          <h4>Talebiniz alındı!</h4>
          <p>Müşteri temsilcimiz en kısa sürede sizi arayarak size özel teklif sunacak.</p>
        </div>

        <form class="aydem-popup__form" v-else @submit.prevent="submitPopup">
          <div class="aydem-popup__row">
            <input type="text" v-model="form.firstName" placeholder="Adınız" required />
            <input type="text" v-model="form.lastName" placeholder="Soyadınız" required />
          </div>
          <input type="email" v-model="form.email" placeholder="E-mail Adresiniz" required />
          <input type="tel" v-model="form.phone" placeholder="Telefon Numaranız" required />
          <button type="submit" class="aydem-popup__submit" :disabled="loading">
            <span v-if="loading">Gönderiliyor...</span>
            <span v-else>Beni Arayın</span>
          </button>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AydemPopup',
  data() {
    return {
      isOpen: false,
      submitted: false,
      loading: false,
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
      },
    };
  },
  methods: {
    async submitPopup() {
      this.loading = true;
      try {
        await axios.get('https://admin.kobisi.com/callme', {
          params: {
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            email: this.form.email,
            phone: this.form.phone,
            source: 'aydem',
          },
        });
        this.submitted = true;
        this.form = { firstName: '', lastName: '', email: '', phone: '' };
      } catch (e) {
        console.error('Callme hatası:', e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.aydem-popup-wrapper {
  position: fixed;
  bottom: 24px;
  left: 10px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;

  @media screen and (max-width: 600px) {
    right: auto;
    left: 100px;
    transform: translateX(-50%);
    align-items: center;
    width: calc(100vw - 32px);
  }
}

// Tetikleyici buton
.aydem-popup-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  background: $primary-color;
  color: $white;
  border: none;
  border-radius: 50px;
  padding: 12px 20px;
  font-size: 0.95em;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.22);
  }

  svg {
    width: 20px;
    height: 20px;
    fill: $white;
  }
}

// Popup kutusu
.aydem-popup {
  background: $white;
  border-radius: 16px;
  box-shadow: 0 16px 56px rgba(0, 0, 0, 0.18);
  width: 340px;
  padding: 28px 24px 24px;
  position: relative;

  @media screen and (max-width: 480px) {
    width: calc(100vw - 32px);
  }

  &__close {
    position: absolute;
    top: 14px;
    right: 16px;
    background: none;
    border: none;
    font-size: 1em;
    color: lighten($text-color, 40%);
    cursor: pointer;
    line-height: 1;
    padding: 4px;
    transition: color 0.2s;

    &:hover {
      color: $text-color;
    }
  }

  &__header {
    text-align: center;
    margin-bottom: 20px;

    h3 {
      font-size: 1.25em;
      font-weight: 800;
      margin-bottom: 8px;
      color: $text-color;
    }

    p {
      font-size: 0.88em;
      color: lighten($text-color, 25%);
      line-height: 1.5;
    }
  }

  &__success {
    text-align: center;
    padding: 24px 0 16px;

    &-icon {
      margin: 0 auto 16px;
      width: 64px;
      height: 64px;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    h4 {
      font-size: 1.2em;
      font-weight: 800;
      color: $text-color;
      margin-bottom: 8px;
    }

    p {
      font-size: 0.88em;
      color: lighten($text-color, 25%);
      line-height: 1.5;
    }
  }

  &__form {
    display: flex;
    flex-direction: column;
    gap: 10px;

    input {
      width: 100%;
      border: 1.5px solid darken($gray, 15%);
      border-radius: 8px;
      padding: 11px 14px;
      font-size: 0.9em;
      outline: none;
      transition: border-color 0.2s;
      box-sizing: border-box;

      &:focus {
        border-color: $primary-color;
      }

      &::placeholder {
        color: lighten($text-color, 45%);
      }
    }
  }

  &__row {
    display: flex;
    gap: 10px;

    input {
      flex: 1;
    }
  }

  &__submit {
    margin-top: 6px;
    background: $primary-color;
    color: $white;
    border: none;
    border-radius: 50px;
    padding: 13px;
    font-size: 1em;
    font-weight: 700;
    cursor: pointer;
    width: 100%;
    transition: opacity 0.2s, transform 0.2s;

    &:hover:not(:disabled) {
      opacity: 0.9;
      transform: translateY(-1px);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}

// Açılma animasyonu
.popup-slide-enter-active,
.popup-slide-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.popup-slide-enter,
.popup-slide-leave-to {
  opacity: 0;
  transform: translateY(16px) scale(0.97);
}
</style>
